/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeploymentDocker = {
  /**
   * The OCI image reference requested for this deployment.
   */
  image: string;
};

/** @internal */
export const DeploymentDocker$inboundSchema: z.ZodType<
  DeploymentDocker,
  z.ZodTypeDef,
  unknown
> = z.object({
  image: z.string(),
});

export function deploymentDockerFromJSON(
  jsonString: string,
): SafeParseResult<DeploymentDocker, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeploymentDocker$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeploymentDocker' from JSON`,
  );
}
